__turbopack_context__.v({
  "deleteButton": "viewActions-module-scss-module__3Ze4ua__deleteButton",
  "renameButton": "viewActions-module-scss-module__3Ze4ua__renameButton",
  "resetButton": "viewActions-module-scss-module__3Ze4ua__resetButton",
});
